import React from 'react';
import HelpApiLayout from '../../../components/layout/HelpApiLayout';
import ApiSidebar from '../../../components/layout/ApiSidebar';
import './ApiDocsPage.css';

/**
 * Error Codes API Documentation Page
 */
const ErrorCodes = () => {
  const errorCodes = [
    { code: 400, name: 'BAD_REQUEST', description: 'The request was invalid or malformed' },
    { code: 401, name: 'UNAUTHORIZED', description: 'Authentication required or invalid API key' },
    { code: 403, name: 'FORBIDDEN', description: 'You do not have permission to access this resource' },
    { code: 404, name: 'NOT_FOUND', description: 'The requested resource was not found' },
    { code: 429, name: 'RATE_LIMIT_EXCEEDED', description: 'Too many requests. Please slow down' },
    { code: 500, name: 'INTERNAL_SERVER_ERROR', description: 'An internal server error occurred' },
    { code: 503, name: 'SERVICE_UNAVAILABLE', description: 'The service is temporarily unavailable' }
  ];

  return (
    <HelpApiLayout type="api" sidebar={<ApiSidebar />}>
      <div className="api-docs-page">
        <div className="api-docs-page-container">
          <main className="api-docs-main">
            <header className="api-docs-page-header">
              <h1 className="lp-section-title">Error Codes</h1>
              <p className="lp-section-subtitle">
                Reference guide for API error responses and status codes.
              </p>
            </header>

            <section className="api-docs-page-section">
              <h2>HTTP Status Codes</h2>
              <p>
                The API uses standard HTTP status codes to indicate the success or failure
                of a request. Error responses include a JSON body with details about the error.
              </p>
            </section>

            <section className="api-docs-page-section">
              <h2>Error Response Format</h2>
              <p>All error responses follow this format:</p>
              <pre className="error-format-example">
{`{
  "error": {
    "code": "ERROR_CODE",
    "message": "Human-readable error message",
    "details": {}
  }
}`}
              </pre>
            </section>

            <section className="api-docs-page-section">
              <h2>Common Error Codes</h2>
              <div className="error-codes-table">
                <table>
                  <thead>
                    <tr>
                      <th>Status Code</th>
                      <th>Error Code</th>
                      <th>Description</th>
                    </tr>
                  </thead>
                  <tbody>
                    {errorCodes.map((error) => (
                      <tr key={error.code}>
                        <td><code>{error.code}</code></td>
                        <td><code>{error.name}</code></td>
                        <td>{error.description}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </section>

            <section className="api-docs-page-section">
              <h2>Handling Errors</h2>
              <p>
                Always check the response status code and handle errors appropriately in your
                application. Retry logic should be implemented for 5xx errors, while 4xx errors
                typically indicate issues with the request that need to be fixed.
              </p>
            </section>
          </main>
        </div>
      </div>
    </HelpApiLayout>
  );
};

export default ErrorCodes;
